module.exports = __webpack_public_path__ + "static/media/funcacion-mas.7c8a0fcc.png";